import React from "react";
import AdminPanelLayaut from "./layaut/AdminPanelLayaut";
import Kafelek from "./component/Kafelek";
import {Flex} from "antd";
import { ContainerOutlined, UserOutlined, SettingOutlined } from '@ant-design/icons';
import {isSuperAdmin} from "../../../GlobalServices";

const PanelGlowny = () => {
    return (
        <AdminPanelLayaut label={'Panel główny'}>
            <Flex gap={5}>
                <Kafelek label={'Zgłoszenia'} icon={<ContainerOutlined />} url={'/admin/zgloszenia'}/>
                <Kafelek label={'Użytkownicy'} icon={<UserOutlined />} url={'/admin/uzytkownicy'} ukryj={!isSuperAdmin()}/>
                <Kafelek label={'Ustawienia'} icon={<SettingOutlined />} url={'/admin/ustawienia'}/>
            </Flex>
        </AdminPanelLayaut>
    )
}

export default PanelGlowny;
